import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDifiLdIzC9T4Miawr9KC3rImbj6tTtf7Q",
    authDomain: "ag-uat.firebaseapp.com",
    projectId: "ag-uat",
    storageBucket: "ag-uat.firebasestorage.app",
    messagingSenderId: "921425293628",
    appId: "1:921425293628:web:eea6abb7ec48114874ae39",
    measurementId: "G-QL9L9HFBSF"
};

class FirebaseLogger {
  constructor() {
    this.app = null;
    this.analytics = null;
    this.initializeFirebase();
  }

  initializeFirebase() {
    try {
      this.app = initializeApp(firebaseConfig);
      this.analytics = getAnalytics(this.app);
      if (!this.analytics) {
        throw new Error("Firebase Analytics not initialized");
      }
    } catch (error) {
      console.error("Error initializing Firebase:", error);
    }
  }

  logEventToFirebase(eventName, eventParams = {}) {
    if (!this.analytics) {
      console.error("Firebase Analytics is not initialized");
      return;
    }
    try {
      logEvent(this.analytics, eventName, eventParams);
      // console.log(`Event logged: ${eventName}`, eventParams);
    } catch (error) {
      console.error("Error logging event to Firebase Analytics:", error);
    }
  }

  logInfo(eventName, eventParams = {}) {
    this.logEventToFirebase(eventName, { ...eventParams, level: "info" });
  }

  logWarning(eventName, eventParams = {}) {
    this.logEventToFirebase(eventName, { ...eventParams, level: "warning" });
  }

  logError(eventName, eventParams = {}) {
    this.logEventToFirebase(eventName, { ...eventParams, level: "error" });
  }
}

export default FirebaseLogger;
